<template>
	<div id="Dynamic">
		<div class="Dynamic_box">
			<div class="layer"></div>
			<div class="Dynamic_out">
				<div class="container" :style="LeftSty" :class="TranSitionSty">
					<div class="contItem" :style="'width:' +WidTh+ 'px;margin-left:' +MarGin+ 'px;margin-right:' +MarGin+ 'px'" v-for="(item,index) in DetailArr" :key="index">
						<div class="cont_pic" :style="{'background-image': 'url('+item.lv_bg_image+')'}">
							<img :src="item.cover" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Dynamic',
		props: {
			DetailList: { 
				type: Array
			},
			Awardlist:{
				type: Array
			},
			Dynamic_checked:{
				type:String
			},
			Dynamic_num:{
				type:Number
			}
		},

		data() {
			return {
				LeftSize: '0',
				TranSition:'active',
				DetailArr: [],
				also:0,
				process: new Audio(require('@/assets/audio/process.mp3')),
				WidTh:200,
				MarGin:20,
			}
		},


		methods: {
	
			Arraysplicing() {
				let A_Arr = []
				for (let i = 0; i < 25; i++) {
					A_Arr = A_Arr.concat(this.DetailList)
				}
				function randSort(A_Arr) {
					for (let i = 0, len = A_Arr.length; i < len; i++) {
						let rand = parseInt(Math.random() * len)
						let temp = A_Arr[rand]
						A_Arr[rand] = A_Arr[i]
						A_Arr[i] = temp
					}
					return A_Arr
				}
				this.DetailArr = randSort(A_Arr)
			},
			

			Determine(){
				if(this.also < this.Dynamic_num){
					this.DetailArr[32] = this.Awardlist[this.also]
					this.TranSition = 'active'
					this.LeftSize = -((this.WidTh * 31 + (this.MarGin * 2) * 31) - this.MarGin/5)
					this.process.play()
					this.also += 1
					setTimeout(() => {
						this.IsRepeat()
					},6900)
				}else{
					
					this.$emit('setAnimation', true)
				}				
			},
			
	
			IsRepeat(){
				
				this.$emit('setEquipment', this.also)
				let alsoArr = []
				alsoArr.unshift(this.DetailArr[31],this.DetailArr[32],this.DetailArr[33])
				this.Arraysplicing()
				this.DetailArr = alsoArr.concat(this.DetailArr)
				this.TranSition = ''
				this.LeftSize = '0'
				setTimeout(() => {
					this.Determine()
				},100)
			}
		},

		computed: {
		
			LeftSty() {
				return 'transform: translateX(' + (this.LeftSize) + 'px)'
			},
			TranSitionSty(){
				return this.TranSition
			}
		},

		watch: {
			DetailList(arr) {
				if (arr.length > 0) this.Arraysplicing()
			},
			
			Dynamic_checked(str){
				this.also = 0
				if(str == '1') this.Determine()
			},
		}
	}
</script>

<style lang="scss">
	#Dynamic {
		padding: 10px;
		margin-top: -15px;
		box-sizing: border-box;
		.Dynamic_box {
			width: 800px;
			height: 280px;
			margin: 0 auto;
			overflow: hidden;
			position: relative;

			.layer {
				position: absolute;
				left: 0;
				right: 0;
				width: 100%;
				height: 100%;
				background: url(../../assets/images/open/Animation_back.png) no-repeat center;
				background-size: contain;
				z-index: 1;
			}

			.Dynamic_out {
				width: 90%;
				height: 90%;
				margin: 14px auto;
				border-radius: 40px;
				overflow: hidden;
				mask-image:linear-gradient(90deg,rgba(25,25,25,0) 4%,#000 50%,rgba(25,25,25,0) 96%);
				-webkit-mask-image:linear-gradient(90deg,rgba(25,25,25,0) 4%,#000 50%,rgba(25,25,25,0) 96%);
				.container {
					height: 100%;
					display: flex;
					&.active{
						transition: 6s cubic-bezier(0, 0, 0.28, 1);
					}
					.contItem {
						height: 150px;
						margin-top: 50px;
						margin-bottom: 6px;
						background: url(../../assets/images/public/back_pub.jpg) no-repeat center;
						background-size: 100% 100%;
						// border-radius: 6px;
						.cont_pic {
							width: 200px;
							height: 150px;
							background: url(http://www.gameskins.cn/img/LV4.9815642e.png);
							background-repeat: no-repeat;
							background-size: 60%;
							background-position: center;
							display: flex;
							justify-content: center;
							align-items: center;

							img {
								vertical-align: middle;
								max-width: 100%;
								max-height: 100%;
							}
						}
					}
				}
			}
		}


	}
</style>
